/**
 * Column definitions for the currency list table.
 * Used by the web renderer.
 *
 * - `align`: text alignment (`'right'` or omitted for left).
 * - `defaultSortDirection`: `-1` for descending, `1` for ascending.
 *
 * @typedef {{ code: string, name: string, symbol: string, decimalPlaces: number, isBase: boolean|number, isCustom?: boolean, manualRate: number|null|undefined, rate?: number|null }} CurrencyRow
 */

/** @type {Array<{ key: string, label: string, type: string, align?: string, defaultSortDirection?: number, priority?: 1|2|3, getValue: (c: any) => any, getDisplayValue?: (c: any) => string, getSortTieBreaker?: (c: any) => any, tieBreakerDirection?: 1|-1, linkTo?: (row: any) => string|undefined }>} */
export const CURRENCY_COLUMNS = [
	{ key: 'code', label: 'Code', type: 'text', priority: 1, getValue: (c) => c.code },
	{ key: 'type', label: 'Type', type: 'text', priority: 2, getValue: (c) => (c.isCustom ? 'Custom' : 'Standard') },
	{ key: 'name', label: 'Name', type: 'text', priority: 2, getValue: (c) => c.name },
	{ key: 'symbol', label: 'Symbol', type: 'text', priority: 2, getValue: (c) => c.symbol },
	{ key: 'decimalPlaces', label: 'DecPl', type: 'number', priority: 3, getValue: (c) => c.decimalPlaces, getDisplayValue: (c) => String(c.decimalPlaces ?? '') },
	{ key: 'rate', label: 'Rate', type: 'number', defaultSortDirection: -1, priority: 1, getValue: (c) => formatRateValue(c), getDisplayValue: (c) => formatRate(c) },
	{ key: 'isBase', label: 'Base', type: 'text', priority: 2, getValue: (c) => c.isBase ? 'Yes' : 'No' },
];

/**
 * @param {{ manualRate: number | null | undefined, rate?: number | null }} c
 * @returns {number}
 */
export function formatRateValue(c) {
	if (c.manualRate !== null && c.manualRate !== undefined) {
		return c.manualRate;
	}
	return c.rate ?? Number.NEGATIVE_INFINITY;
}

/**
 * @param {{ manualRate: number | null | undefined, rate?: number | null }} c
 * @returns {string}
 */
export function formatRate(c) {
	if (c.manualRate !== null && c.manualRate !== undefined) {
		if (c.manualRate === 0) { return '0.0000 (M)'; }
		return `${c.manualRate.toFixed(4)} (M)`;
	}
	const rate = c.rate ?? null;
	if (rate === null) { return '\u2014'; }
	return rate.toFixed(4);
}
